import { onViewLoad } from "./on_view_load.js";
import { initStickySubnavHeader } from "./sticky_subnav_header.js";

const VIEWS = [
  "users#ingredients",
  "ingredient_metas#index_for_user",
  "ingredient_allergens#index_for_user",
  "users#costs",
];

onViewLoad(VIEWS, () => {
  initStickySubnavHeader();
});
